import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    chatId: "",
    user: {},
};

export const chatUserSlice = createSlice({
  name: "chatUser",
  initialState,
  reducers: {
    setChatUserInfo: (state, action) => {
      state.chatId = action.payload.chatId > action.payload.user.uid
      ? action.payload.chatId + action.payload.user.uid
      : action.payload.user.uid + action.payload.chatId;
      state.user = action.payload.user;
    },
  },
});

export const SelectChatUser = (state) => state.chatUser;

export const { setChatUserInfo } = chatUserSlice.actions;

export default chatUserSlice.reducer;
